import Swal from 'sweetalert2';

// Custom SweetAlert2 configurations following user rules (no alert(), use SWAL)
export const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  },
});

export const showSuccess = (message: string) => {
  return Toast.fire({
    icon: 'success',
    title: message,
  });
};

export const showError = (message: string) => {
  return Toast.fire({
    icon: 'error',
    title: message,
  });
};

export const showWarning = (message: string) => {
  return Toast.fire({
    icon: 'warning',
    title: message,
  });
};

export const showInfo = (message: string) => {
  return Toast.fire({
    icon: 'info',
    title: message,
  });
};

export const confirmAction = (options: {
  title: string;
  text: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  icon?: 'warning' | 'question' | 'info' | 'error' | 'success';
}) => {
  return Swal.fire({
    title: options.title,
    text: options.text,
    icon: options.icon || 'question',
    showCancelButton: true,
    confirmButtonColor: '#3b82f6',
    cancelButtonColor: '#6c757d',
    confirmButtonText: options.confirmButtonText || 'Confirm',
    cancelButtonText: options.cancelButtonText || 'Cancel',
  });
};

export const confirmDelete = (itemName: string) => {
  return confirmAction({
    title: 'Are you sure?',
    text: `You are about to delete ${itemName}. This action cannot be undone.`,
    confirmButtonText: 'Yes, delete it',
    cancelButtonText: 'Cancel',
  });
};

export const showConfirm = async (
  title: string,
  text: string,
  icon: 'warning' | 'question' | 'info' | 'error' | 'success' = 'question'
): Promise<boolean> => {
  const result = await Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonColor: '#3b82f6',
    cancelButtonColor: '#6c757d',
    confirmButtonText: 'Yes',
    cancelButtonText: 'Cancel',
  });
  return result.isConfirmed;
};

export const showLoading = (message: string) => {
  Swal.fire({
    title: message,
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

export const closeLoading = () => {
  Swal.close();
};

